import { AppNameComponent } from './data-widgets/app-name.component';
import { BigNumberDataComponent } from './data-widgets/big-number-data.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { PublisherNameComponent } from './data-widgets/publisher-name.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { ReportConfig } from './REPORT_CONFIG';
import { CTV_OPTIONS } from './REPORT_CONFIG_CONST';

export const REPORT_CONFIG_PUBLISHER_REACH: ReportConfig = {
  key: 'publisher-reach',
  heading: 'Reach',
  title: 'Reach',
  formTitle: 'Publisher Reach rankings',
  pageTitle:
    'Estimated Reach of Publishers, a Pixalate Rankings index:  for {type}',
  pageMeta:
    'Publisher Estimated Reach measures estimated reach for {type} in the {platformName}',
  reportId: 'publisherReach',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  rowLimit: 10,
  fadeStart: 5,
  mainFilterItems: [
    {
      key: 'platformName',
      label: 'OS',
      selected: {
        label:
          '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
        value: 'android'
      },
      groups: ['app'],
      hidden: false,
      type: 'toggle-filter',
      options: [
        {
          label:
            '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
          value: 'android'
        },
        {
          label:
            '<img class="mr-2" src="/assets/images/apple.svg" alt="App Store Icon"/> App Store',
          value: 'ios'
        }
      ]
    },
    {
      key: 'platformName',
      label: 'OS',
      selected: CTV_OPTIONS[0],
      groups: ['ctv'],
      hidden: false,
      type: 'toggle-filter',
      options: [...CTV_OPTIONS]
    },
    {
      key: 'category',
      label: 'Category',
      selected: { label: 'All Categories', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          key: 'countryCode'
        },
        {
          key: 'date'
        },
        {
          key: 'platformName'
        }
      ],
      options: [{ label: 'All Categories', value: 'GLOBAL' }],
      default: { label: 'All Categories', value: 'GLOBAL' }
    },
    {
      key: 'countryCode',
      label: 'Region',
      selected: { label: 'North America', value: 'NA' },
      hidden: false,
      dependencies: [
        {
          key: 'date'
        },
        {
          key: 'platformName'
        }
      ],
      options: [{ label: 'North America', value: 'NA' }],
      default: { label: 'North America', value: 'NA' }
    },
    {
      key: 'countryCode',
      label: 'Country',
      selected: { label: 'All Countries', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          key: 'date'
        },
        {
          key: 'platformName'
        },
        {
          label: 'Region'
        }
      ],
      options: [{ label: 'All Countries', value: 'GLOBAL' }],
      default: { label: 'All Countries', value: 'GLOBAL' }
    },
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'platformName'
        }
      ],
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Rank',
      key: 'mauRank',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null, // <div class="rank-change" data-rank-value="${mauRankChange}">${mauRankChange} <i class="fa fa-arrow-up"></i><i class="fa fa-arrow-down"></i></div>',
      widgetComponent: RankDataComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'App Name',
      key: 'appTitle',
      groups: ['app', 'ctv'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      widgetComponent: AppNameComponent,
      template: null,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Publisher Name',
      key: 'publisherName',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      hidden: false,
      widgetComponent: PublisherNameComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Estimated Reach',
      key: 'mau',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      format: '0.00a',
      template: null,
      widgetComponent: BigNumberDataComponent,
      hidden: false,
      lockIfAnonymous: true,
      lockIfFreemium: true,
      headerWidgetComponent: GridHeaderComponent
    }
  ]
};
